<script setup>
import { Modal, Icon,Input,Textarea,Button } from '@components';
import { computed, onMounted, ref, watch } from 'vue';
import { validationCheck, regex } from '@utils';

import { useRouter } from 'vue-router';
const router = useRouter();

import { useSetup } from '@store/setup';
const $setup = useSetup();

import { useSettings } from '@store/settings';
const $settings = useSettings();

const $options = prebook_admin.options
const site = prebook_admin.site

const backButton = () => {
	router.push({name:'setup'})
}


const nextButton = async() => {
   let { errors } = validationCheck([
      // {
      //    condition: !$settings.business.full_logo_url,
      //    message: 'Full logo is required',
      // },
      {
         condition: !$settings.business.name && $settings.addons.staffs,
         message: 'Company name is required',
      },
      // {
      //    condition: !$settings.business.type,
      //    message: `${$settings.addons.staffs ? 'Company' : 'Service'} type is required`,
      // },
      {
         condition: !$settings.addons.staffs && !$settings.business.provider_first_name,
         message: 'Provider first name is required',
      },
      {
         condition: !$settings.addons.staffs && !$settings.business.provider_last_name,
         message: 'Provider last name is required',
      },
      {
         condition: !$settings.addons.staffs && !$settings.business.provider_display_name,
         message: 'Provider display name is required',
      },
      {
         condition: !$settings.business.email,
         message: 'Email is required',
      },
      {
         condition: $settings.business.email && !regex.email.test($settings.business.email),
         message: 'Invalid email format',
      },
      {
         condition: $settings.business.phone && !regex.phone.test($settings.business.phone),
         message: 'Invalid phone number format',
      },
   ]);
   if (errors) return

   await $settings.saveSettings('business', $settings.business)
   await $setup.saveSetupStep('availability')
	router.push({name:'setup.availability'})
}

const businessType = computed(() => {
   let data = {
      "business": {
         "automotive_services": "Automotive Services",
         "beauty_wellness": "Beauty & Wellness",
         "education_center": "Education Center",
         "entertainment": "Entertainment",
         "event_planning": "Event Planning",
         "fitness_gyms": "Fitness & Gyms",
         "health_medical": "Health & Medical",
         "home_services": "Home Services",
         "hospitality_travel": "Hospitality & Travel",
         "law_firms": "Law Firms",
         "marketing_agency": "Marketing Agency",
         "pet_services": "Pet Services",
         "real_estate_agency": "Real Estate Agency",
         "tax_advisors": "Tax Advisors",
         "training_center": "Training Center",
         "sports_gaming": "Sports & Gaming",
         "other": "Other"
      },
      "personal": {
         "accountant": "Accountant",
         "artist": "Artist",
         "consultant": "Consultant",
         "dietitians": "Dietitians",
         "freelancer": "Freelancer",
         "instructor": "Instructor",
         "lawyer": "Lawyer",
         "makeup_artist": "Makeup Artist",
         "nutritionist": "Nutritionist",
         "personal_trainer": "Personal Trainer",
         "photographer": "Photographer",
         "physiotherapist": "Physiotherapist",
         "psychotherapist": "Psychotherapist",
         "other": "Other"
      }
   }

   // const types = $options.business_types;
   console.log($settings.addons['staffs'])
   const types = $settings.addons['staffs']? data.business : data.personal;
   return Object.entries(types).map(([value, label]) => ({
      label,
      value
   }));
})

const showAllTypes = ref(false);

// Check if selected item is beyond first 7 items
const shouldShowAll = () => {
   const types = businessType.value;
   if ($settings.business.type) {
      const selectedIndex = types.findIndex(type => type.value === $settings.business.type);
      return selectedIndex >= 7;
   }
   return false;
}

// Initialize on mount
onMounted(() => {
   showAllTypes.value = shouldShowAll();
});

// Watch for changes in selected business type
// watch(() => $settings.business.type, () => {
//    showAllTypes.value = shouldShowAll();
// });

const visibleBusinessTypes = computed(() => {
   const types = businessType.value;
   return showAllTypes.value ? types : types.slice(0, 7);
});

const toggleShowMore = () => {
   showAllTypes.value = !showAllTypes.value;
}

const changeType = (type) => {
   $settings.business.type = type.value;
}
</script>


<template>
  	<Modal :progress="33" class="transition duration-100 bg-white" contentClass="!p-0">
      <template #header>
			<div class="px-8 py-5 border-b-[#EAECF0] border-b flex items-center justify-between shadow-[0px_3px_0px_0px_#eaecf0]">
            <Icon name="logoLight" size="56px"/>
            <Icon @click="$setup.crossButton" class="cursor-pointer" name="xClose" size="30px"></Icon>
			</div>
		</template>

      <template #default>
        <div class="flex flex-col md:flex-row">
         <div class="w-full lg:w-[calc(100%-738px)] h-full mb-5">
            <div class="mt-[70px] max-w-[750px] m-auto px-8 lg:px-[48px]">
               <div class="text-base font-medium text-[#101828]">General / <span class="font-bold">{{ $setup.isBusiness ? 'Business' : 'Individual' }}</span></div>
               <div class="text-[30px] font-bold text-[#101828] mt-2">Information</div>
               <div class="text-base text-[#475467] mt-2">{{ $setup.isBusiness ? "Great choice! Let's set up your business profile so you can start taking bookings. You can edit or remove them later." : "Great choice! Let's set up your profile so you can start taking bookings. You can edit or remove them later." }}</div>

               <div class="mt-10 relative" v-if="$setup.isBusiness">
                  <Icon name="arrowRight" size="18px" class="absolute top-1 left-[-30px] text-[#101828]"></Icon>
                  <div class="text-[#101828] text-[20px] font-medium">What's your business name?</div>
                  <Input required v-model="$settings.business.name" placeholder="Beauty Salon" type="text" class="mt-5"></Input>
               </div>
               <div class="mt-10 relative" v-if="!$setup.isBusiness">
                  <Icon name="arrowRight" size="18px" class="absolute top-1 left-[-30px] text-[#101828]"></Icon>
                  <div class="text-[#101828] text-[20px] font-medium">What's your name?</div>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
                     <div class="w-full">
                        <div class="text-[#344054] text-sm font-medium">First Name</div>
                        <Input required v-model="$settings.business.provider_first_name" placeholder="Gray" type="text" class="mt-1"></Input>
                     </div>
                     <div class="w-full">
                        <div class="text-[#344054] text-sm font-medium">Last Name</div>
                        <Input required v-model="$settings.business.provider_last_name" placeholder="Matter" type="text" class="mt-1"></Input>
                     </div>
                  </div>
               </div>
               <div class="mt-10 relative" v-if="!$setup.isBusiness">
                  <Icon name="arrowRight" size="18px" class="absolute top-1 left-[-30px] text-[#101828]"></Icon>
                  <div class="text-[#101828] text-[20px] font-medium">What do you want to display on the booking page?</div>
                  <Input required v-model="$settings.business.provider_display_name" placeholder="Gray Matter Law" type="text" class="mt-5"></Input>
               </div>
               <div class="mt-[30px] relative">
                  <Icon name="arrowRight" size="18px" class="absolute top-1 left-[-30px] text-[#101828]"></Icon>
                  <div class="text-[#101828] text-[20px] font-medium">{{ $setup.isBusiness ? "What's your business type?" : "What type of service do you offer?" }}</div>
                  <div class="flex flex-col gap-3 mt-5">
                     <div class="flex flex-wrap gap-2 lg:gap-3">
                        <div @click="changeType(type)" v-for="type in visibleBusinessTypes" class="text-sm md:text-base font-semibold border rounded-[100px] px-4 py-[10px] shadow-[0px_1px_2px_0px_#1018280D] cursor-pointer" :class="type.value == $settings.business.type ? 'text-white border-[#7F56D9] bg-[#7F56D9]' : 'border-[#D0D5DD] text-[#344054] bg-white'">{{ type.label }}</div>
                        <button 
                           v-if="businessType.length > 7"
                           @click="toggleShowMore" 
                           class="text-[#6941C6] text-sm font-medium cursor-pointer px-4 py-[10px]">
                           {{ showAllTypes ? 'Show Less' : 'Show More' }}
                        </button>
                     </div>
                  </div>
               </div>
               <div class="mt-[30px] relative">
                  <Icon name="arrowRight" size="18px" class="absolute top-1 left-[-30px] text-[#98A2B3]"></Icon>
                  <div class="text-[#101828] text-[20px] font-medium">Tell us a bit about {{ $setup.isBusiness ? 'your business' : 'yourself' }} <span class="text-[#98A2B3]">(optional)</span></div>
                  <Textarea v-model="$settings.business.about" :placeholder="$setup.isBusiness ? 'Creating a perfect look for any occasion with personalized beauty services.' : 'Providing expert legal guidance for every case with personalized legal services.'" class="mt-5" textareaClass="h-[130px]" />
               </div>
               <div class="mt-[30px] relative">
                  <Icon name="arrowRight" size="18px" class="absolute top-1 left-[-30px] text-[#101828]"></Icon>
                  <div class="text-[#101828] text-[20px] font-medium">Your business email</div>
                  <Input required v-model="$settings.business.email" placeholder="contact@yourbusiness.com" type="email" class="mt-5"></Input>
                  <Button class="mt-2" type="secondary_color" v-if="!$settings.business.email" @click="$settings.business.email = site.admin_email">Use
                     {{ site.admin_email }}</Button>
               </div>
               <div class="mt-[30px] relative">
                  <Icon name="arrowRight" size="18px" class="absolute top-1 left-[-30px] text-[#98A2B3]"></Icon>
                  <div class="text-[#101828] text-[20px] font-medium">Your contact number <span class="text-[#98A2B3]">(optional)</span></div>
                  <Input required v-model="$settings.business.phone" placeholder="+1 012 345 6789" type="tel" class="mt-5"></Input>
               </div>

               <div class="flex items-center gap-10 mt-10">
                  <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] justify-between" @click="backButton">
                     <div class="w-[70%]">Back</div>
                     <template #before>
                        <Icon name="arrowNarrowLeft" size="20px"></Icon>
                     </template>
                  </Button>
                  <Button size="xl" type="primary" radius="square" classButton="w-full justify-between" @click="nextButton">
                     <div class="w-[95%]">Continue</div>
                     <template #after>
                        <Icon name="arrowNarrowRight" size="20px"></Icon>
                     </template>
                  </Button>
               </div>
            </div>
         </div>
         <div class="hidden md:block relative w-[738px] min-h-full overflow-hidden">
            <div class="circle-1"></div>
            <div class="circle-2"></div>
            <div class="circle-3"></div>
            <div class="text-lg font-medium text-[#344054] mt-[26px] ml-[36px] relative">Preview</div>
            <div class="mt-[67px]">
               <div class="relative w-[482px] h-[535px] m-auto rounded-[20px]" :style="`background: url(${Image('setup-info-top.png')});`">
                  <!-- <img :src="" class="max-w-[482px] m-auto mt-[67px] relative"></img> -->
                  <div class="absolute left-[40px] bottom-[40px] w-[402px]">
                     <div class="text-lg font-semibold text-white">{{ $settings.addons.staffs ? ($settings.business.name?$settings.business.name:'Beauty Salon'): ($settings.business.provider_display_name ? $settings.business.provider_display_name : 'Gray Matter Law') }}</div>
                     <!-- <div class="text-sm text-white mt-5">{{ $settings.addons.staffs ? ($settings.business.about?$settings.business.about:($setup.isBusiness ? 'Creating a perfect look for any occasion with personalized beauty services.' : 'Providing expert legal guidance for every case with personalized legal services.')):($setup.isBusiness ? 'Creating a perfect look for any occasion with personalized beauty services.' : 'Providing expert legal guidance for every case with personalized legal services.') }}</div> -->
                     <div class="text-sm text-white mt-5">
                        {{$settings.business.about?$settings.business.about:($setup.isBusiness ? 'Creating a perfect look for any occasion with personalized beauty services.' : 'Providing expert legal guidance for every case with personalized legal services.')}}
                     </div>
                   </div>
               </div>
               <img class="w-[482px] m-auto" :src="Image('setup-info-bottom.png')" />
            </div>
         </div>
        </div>
      </template>
  	</Modal>
</template>

<style>
</style>